<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Upload Photos </span>
        </v-row>
        <br />
        <v-card class="card">
            <center class="heading">
                <h3>Upload Student Photos</h3>
            </center>

            <v-card class="box">
                <div class="flex">
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" lg="4" sm="12">
                                <v-file-input
                                    v-model="file"
                                    dense
                                    color="rgb(1, 127, 152)"
                                    counter
                                    :hint="file != null ? '':'Please Select Photo'"
                                    persistent-hint
                                    ref="file"
                                    label="Select Multiple Photos"
                                    multiple
                                    prepend-icon="mdi-paperclip"
                                    outlined
                                    show-size
                                    accept="image/jpeg"
                                >
                                    <template v-slot:selection="{ index, text }">
                                        <v-chip v-if="index < 3" color="rgb(1, 127, 152)" dark label small>
                                            {{ text }}
                                        </v-chip>

                                        <span v-else-if="index === 3" class="overline grey--text text--darken-3 mx-2">
                                            +{{ file.length - 3 }} File(s)
                                        </span>
                                    </template>
                                </v-file-input>
                            </v-col>
                            <v-col cols="12" lg="2" sm="12">
                                <center>
                                    <v-btn :loading="loading3" :disabled="loading3" class="button" @click="submitFile">
                                        Upload
                                        <v-icon right>mdi-cloud-upload</v-icon>
                                    </v-btn>
                                </center>
                            </v-col>
                        </v-row>
                        <v-row> </v-row>
                    </v-card-text>
                </div>
            </v-card>

            <br />
            <v-card>
                <template v-if="load==true">
                    <v-data-table :headers="headers" :items="user_list" sort-by="ptype" class="elevation-1" :search="search">
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Photos</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                                <download-excel :data="user_list" :fields="table_fields" worksheet="Photo Upload " name="Student_Photo_Upload.xls">
                                    <v-btn
                                        class="ma-1 white--text"
                                        color="green"
                                        >
                                        <v-icon dark>
                                           mdi-file-excel-box
                                        </v-icon>
                                         Export to Excel
                                    </v-btn>
                                </download-excel>
                                <v-dialog v-model="dialog" max-width="400px">
                                    <v-card>
                                        <v-card-title class="heading">
                                            <span class="headline">{{ formTitle }} </span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container>
                                                <h4 align-self="center">User Name : {{updatedata.username}}</h4>
                                                <v-row>
                                                    <v-col cols="12" align-self="center" v-if="photopreview">
                                                        <img :src="photopreview" width="330px" height="270px" />
                                                    </v-col>
                                                    <v-col cols="12" align-self="center" v-else>
                                                        <!-- <img :src="photopreview" width="330px" height="270px" /> -->
                                                        <center>
                                                            <v-avatar class="avtar" size="180">
                                                                <v-icon dark size="160">mdi-account-circle</v-icon>
                                                            </v-avatar>
                                                        </center>
                                                    </v-col>
                                                    <br />
                                                    <v-file-input placeholder="Select New Photos" prepend-icon="mdi-file" show-size v-model="file1" accept="image/jpeg"></v-file-input>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="button" @click="updatephoto">Update</v-btn>
                                            <v-btn class="button-cancel" text @click="close">Close</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.photopath="{ item }">
                            <div v-if="item.photfilename == 'Photo is Uploaded'">
                                <v-avatar size="33" class="edit-avatar">
                                    <v-icon color="gray" size="18" @click="photopreviewfun(item)">mdi-eye</v-icon>
                                </v-avatar>
                            </div>
                            <div v-if="item.photfilename == 'Photo not Upload.'">
                                <v-avatar size="33" class="edit-avatar">
                                    <v-icon color="rgb(1, 127, 152)" size="18" @click="photopreviewfun(item)">mdi-cloud-upload</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                        <template v-slot:item.photfilename="{ item }">
                            <div v-if="item.photfilename == 'Photo is Uploaded'">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                            <div v-if="item.photfilename == 'Photo not Upload.'">
                                <v-icon color="error">mdi-close-circle</v-icon>
                            </div>
                        </template>
                         <template v-slot:item.photoupload="{ item }">
                            <div v-if="item.photfilename == 'Photo is Uploaded'">
                                Yes
                            </div>
                            <div v-if="item.photfilename == 'Photo not Upload.'">
                                 No
                            </div>
                        </template>
                    </v-data-table>
                    <div v-if="studname" style="color: red;">
                        <v-simple-table style="color: red;">
                            <h2></h2>
                            <template>
                                <thead>
                                    <tr>
                                        <th class="text-left">Sr. No.</th>
                                        <th class="text-left">Photo Not Upload Student GR No.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="snot in studname" :key="snot.data">
                                        <td>{{ snot.srno}}</td>
                                        <td>{{ snot.data }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>
                </template>
            </v-card>
            <v-dialog v-model="dialog_send" hide-overlay persistent width="300">
                <v-card color="#4CAF50" dark>
                    <v-card-text>
                        "Please wait..." while file is uploading?
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card>
        <div class="text-center">
            <v-overlay :value="overlay">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            </v-overlay>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            overlay: false,
            table_fields: {
                "Sr. No.": "sr",
                "Username": "username",
                "Photo Upload Status": "photouploadsta",
            },
            photopath: "",
            file: null,
            file1: null,
            loading3: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            load: false,
            dialog: false,
            user_list: "",
            org: "",
            photopreview: "",
            dialog_send: false,
            headers: [
                { text: "Sr.NO", value: "sr" },
                { text: "User Name", value: "username" },
                { text: "IsUploaded", value: "photfilename" },
                { text: "Photo Upload Status", value: "photoupload" },
                { text: "Photo Preview", value: "photopath" },
            ],
            editedIndex: -1,
            updatedata: {
                recordid: "",
                username: "",
            },
            studname: "",
        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Photo Preview" : "Update / Preview Photo";
            },
        },
        watch: {
            dialog(val) {
                val || this.close();
            },
        },
        mounted() {
            this.overlay = true
            axios
                .post("UploadPhoto/photoUploadHome")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.user_list = res.data.user_list;
                        this.photopath = res.data.photopath;
                        this.org = res.data.org;
                        this.load = true;
                        this.overlay = false
                        // this.showSnackbar("#4CAF50", "Data Load Successfully !!");
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
        methods: {
            submitFile() {
                if (this.file == null) {
                    this.showSnackbar("#b71c1c", "Please select the file!");
                } else {
                    this.output_load = true;
                    let formData = new FormData();

                    for (var i = 0; i < this.file.length; i++) {
                        let file = this.file[i];
                        console.log(file);
                        formData.append("files[" + i + "]", file);
                    }
                    this.dialog_send = true;
                    this.loading3 = true;
                    axios
                        .post("UploadPhoto/uploadPhoto", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then((res) => {
                            if (res.data.msg == "200") {
                                this.dialog_send = false;
                                this.loading3 = false;
                                this.studname = res.data.studList;
                                this.showSnackbar("#4CAF50", "Photo Upload Successfully !!");
                                this.loaddata();
                            } else {
                                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            }
                        })
                        .catch(function () {
                            console.log("FAILURE!!");
                        })
                        .finally(() => {
                            this.output_load = false;
                            this.file = null;
                        });
                    //     }
                }
            }, //end of the fuction

            updatephoto() {
                if (this.file1 == null) {
                    this.showSnackbar("#b71c1c", "Please select the new Photo!");
                } else {
                    this.output_load = true;
                    let formData = new FormData();
                    formData.append("file", this.file1);
                    formData.append("userid", this.updatedata.recordid);
                    this.dialog = false;
                    this.dialog_send = true;
                    axios
                        .post("UploadPhoto/updatePhoto", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then((res) => {
                            if (res.data.msg == "200") {
                                this.course_list = res.data.course_list;
                                this.showSnackbar("#4CAF50", "Photo Update Successfully !!");
                                this.dialog_send = false;
                                this.loaddata();
                            } else {
                                this.showSnackbar("#b71c1c", res.data.usermsg);
                            }
                        })
                        .catch(function () {
                            console.log("FAILURE!!");
                        })
                        .finally(() => {
                            this.output_load = false;
                            this.file1 = null;
                        });
                    //     }
                }
            }, //end of the update fuction

            loaddata() {
                //alert('I am In Load Fun')
                axios
                    .post("UploadPhoto/photoUploadHome")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.user_list = res.data.user_list;
                            this.photopath = res.data.photopath;
                            this.load = true;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            photopreviewfun(item) {
                this.editedIndex = this.user_list.indexOf(item);
                this.photopreview = item.photopath;
                this.updatedata.recordid = item.id;
                this.updatedata.username = item.username;
                this.dialog = true;
            },

            close() {
                this.dialog = false;
                this.initializeErrorMsgFalse();
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },
        },
    };
</script>
<style scoped>
.import_excel_btn{
    margin-left: 10px;
    text-align: center;
}
    .downbtn {
        float: right;
    }
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
    .avtar {
        background: linear-gradient(90deg, hsla(173, 89%, 70%, 1) 0%, hsla(196, 68%, 38%, 1) 100%);
    }
    .box {
        background-color: #add8e630;
        margin: 8px !important;
        padding: 8px;
    }
    .flex {
        display: flex;
        justify-content: space-between;
    }
    @media only screen and (max-width: 600px) {
        .flex {
            display: block;
        }
    }
</style>
